import * as React from "react";
import { useEffect, useState, useContext } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { ProjectContext } from "../../utils/projectContext";
import "./iconLibrary.scss";
import { Input, Empty, Tooltip, message, Popconfirm } from "antd";
import {
  ArrowLeft,
  ArrowRight,
  PlaylistAdd,
  FileOpen,
} from "@mui/icons-material";
import {
  getIconCategoryList,
  getIconList,
  getOssPolicy,
  saveIconInfo,
  createIconCategory,
  updateIconCategory,
  deleteIconCategory,
  duplicateIconCategory,
  getDuplicateIconList,
  updateDuplicateIconCategory
} from "../../api/icon";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function IconLibrary(props) {
  const { open, setOpen } = props;
  const { dialogOpen, setDialogOpen } = useContext(ProjectContext);
  const { classNow, setClassNow } = useContext(ProjectContext);
  const { imgs, setImgs } = useContext(ProjectContext);
  const { Search } = Input;
  const { layerCount, setLayerCount } = useContext(ProjectContext);
  const { layerNow, setLayerNow } = useContext(ProjectContext);
  const { setIconsNow } = useContext(ProjectContext);
  const [contextMenu, setContextMenu] = useState(null);
  const [categoryNow, setCategoryNow] = useState({})
  const {setNewDuplicateIcons} = useContext(ProjectContext);

  const handleContextMenu = (e, icon) => {
    e.preventDefault();
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      icon,
    });
  };

  const handleCloseContextMenu = () => setContextMenu(null);

  const handleEdit = async () => {
    // console.log("编辑：", contextMenu.icon);
    const res = await getIconList({ categoryId: Number(contextMenu.icon.id) });
    if (res.code === 200) {
      localStorage.setItem("cardType", "edit")
      setCategoryNow(contextMenu.icon)
      setSelectedIcons(res.data);
      setDialogOpen(true)

    } else {
      console.log("获取图标列表失败:", res);
    }
    handleCloseContextMenu();
  };

  const handleDelete = async () => {
    // console.log("删除：", contextMenu.icon);
    try {
      const res = await deleteIconCategory(contextMenu.icon.id);
      if (res.code === 200) {
        message.success("图标类删除成功");
        // 刷新自定义类列表
        fetchCustomClasses({
          isStandard: false,
        });
      } else {
        message.error("图标类删除失败");
      }
    } catch (error) {
      message.error("删除图标类时发生错误");
      console.error("删除图标类时发生错误:", error);

    }
    handleCloseContextMenu();
  };

  useEffect(() => {
    const handleClickOutside = () => handleCloseContextMenu();
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);


  const handleClose = () => {
    setCurrentPage(0);
    setSelectedTab("standard");
    setSearchValue(""); // 清空搜索框
    setOpen(false);
  };

  const [selectedTab, setSelectedTab] = useState("standard");
  const [searchValue, setSearchValue] = useState(""); // 搜索框内容

  const handleTabClick = async (tab) => {
    setSelectedTab(tab);
    setCurrentPage(0);
    setSearchValue(""); // 切换tab时清空搜索框
    if (tab === "standard") {
      fetchStandardLibraryIcons({
        isStandard: true,
      });
    } else if (tab === "custom") {
      fetchCustomClasses({
        isStandard: false,
      });
    } else if (tab === "uncategorized") {
      fetchicons();
    }
  };

  const onSearch = (value) => {
    setSearchValue(value);
    if (selectedTab === "standard") {
      fetchStandardLibraryIcons({
        name: value,
        isStandard: true,
      });
    } else if (selectedTab === "custom") {
      fetchCustomClasses({
        name: value,
        isStandard: false,
      });
    } else if (selectedTab === "uncategorized") {
      // if (value !== "") {
      //   const filteredIcons = unclassifiedIcon.filter(
      //     (icon) => icon.name && icon.name.includes(value)
      //   );
      //   setUnclassifiedIcon(filteredIcons);
      // } else {
      //   fetchicons();
      // }
      fetchicons({
        name: value,
      });
    }
  };

  const PAGE_SIZE = 12;
  const [standardLibraryIcon, setStandardLibraryIcon] = useState([]); // 标准库图标
  const [customClass, setCustomClass] = useState([]); // 自定义类图标
  const [unclassifiedIcon, setUnclassifiedIcon] = useState([]); // 未分类图标
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = Math.ceil(standardLibraryIcon.length / PAGE_SIZE);
  const totalCustomPages = Math.ceil(customClass.length / PAGE_SIZE);
  const totalUnclassifiedPages = Math.ceil(unclassifiedIcon.length / PAGE_SIZE);

  const handlePrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };
  const handleCustomPrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };
  const handleUnclassifiedPrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };
  const handleCustomNext = () => {
    if (currentPage < totalCustomPages - 1) setCurrentPage(currentPage + 1);
  };
  const handleUnclassifiedNext = () => {
    if (currentPage < totalUnclassifiedPages - 1)
      setCurrentPage(currentPage + 1);
  };

  const currentIcons = standardLibraryIcon.slice(
    currentPage * PAGE_SIZE,
    (currentPage + 1) * PAGE_SIZE
  );

  const currentCustomClasses = customClass.slice(
    currentPage * PAGE_SIZE,
    (currentPage + 1) * PAGE_SIZE
  );

  const currentUnclassifiedIcons = unclassifiedIcon.slice(
    currentPage * PAGE_SIZE,
    (currentPage + 1) * PAGE_SIZE
  );

  const fetchStandardLibraryIcons = async (data) => {
    try {
      const response = await getIconCategoryList(data);
      if (response.code === 200) {
        setStandardLibraryIcon(response.data);
      } else {
        console.error("获取图标分类失败:", response);
      }
    } catch (error) {
      console.error("请求图标分类数据时发生错误:", error);
    }
  };

  const fetchCustomClasses = async (data) => {
    try {
      const response = await getIconCategoryList(data);
      if (response.code === 200) {
        setCustomClass(response.data);
      } else {
        console.error("获取自定义类失败:", response);
      }
    } catch (error) {
      console.error("请求自定义类数据时发生错误:", error);
    }
  };

  const fetchicons = async (data) => {
    try {
      const response = await getIconList(data);
      if (response.code === 200) {
        setUnclassifiedIcon(response.data);
      } else {
        console.error("获取未分类图标失败:", response);
      }
    } catch (error) {
      console.error("请求未分类图标数据时发生错误:", error);
    }
  };

  useEffect(() => {
    fetchStandardLibraryIcons({
      isStandard: true,
    });
  }, []);

  const getFigmaImages = async () => {
    fetch("https://libra-api-dev.zhilingtech.com/api/icon/list-images", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setUnclassifiedIcon(data.data);
        console.log("Success:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const { addOpen, setAddOpen } = useContext(ProjectContext);
  const handleAddClose = () => {
    setCurrentPage(0);
    setSearchValue("");
    setAddOpen(false);
  };
  const { selectedIcons, setSelectedIcons } = useContext(ProjectContext);
  const toggleIconSelect = (icon) => {
    setSelectedIcons((prev) => {
      const exists = prev.some((item) => item.id === icon.id);
      if (exists) {
        return prev.filter((item) => item.id !== icon.id);
      } else {
        return [...prev, { id: icon.id, url: icon.url }];
      }
    });
  };
  const [selectedPage, setSelectedPage] = useState(0);
  const uploadImg = async () => {
    const res = await getOssPolicy();
    const ossPolicy = res.data;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".png,.jpg,.webp,.jpeg";
    input.style.display = "none";

    input.onchange = async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;

      if (!["image/png", "image/jpeg", "image/webp", "image/jpeg"].includes(file.type)) {
        message.error("只支持上传 PNG、JPG 或 WEBP 格式的图片");
        return;
      }

      const fileKey = `icons/${file.name}`;

      const formData = new FormData();
      formData.append("key", fileKey);
      formData.append("OSSAccessKeyId", ossPolicy.accessid);
      formData.append("policy", ossPolicy.policy);
      formData.append("Signature", ossPolicy.signature);
      formData.append("file", file);

      try {
        const resp = await fetch(ossPolicy.host, {
          method: "POST",
          body: formData,
        });

        if (resp.ok) {
          const fileUrl = `/${fileKey}`;
          const res = await saveIconInfo({
            name: file.name,
            path: fileUrl,
            type: file.type,
            size: file.size,
          });
          if (res.code === 200) {

            if (dialogOpen) {
              const img = res.data;
              
              setSelectedIcons((prev) => [...prev, { id: img.id, url: resp.url+`/${fileKey}` }]);
            } else {
              fetchicons();
            }
            message.success("图标上传成功");
          } else {
          }
        } else {
          console.error("上传失败", await resp.text());
        }
      } catch (err) {
        console.error("上传异常：", err);
      }
    };

    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  };
  const [className, setClassName] = useState("");
  const createClass = async () => {
    try {
      const cardType = localStorage.getItem("cardType");
      if (cardType === "create") {
        if (!className || className.trim() === "") {
          message.warning("图标类名称不能为空");
          return;
        }
        const res = await createIconCategory({
          name: className,
          iconIds: selectedIcons.map((icon) => icon.id),
        });
        if (res.code === 200) {
          message.success("图标类创建成功");
          fetchCustomClasses({
            isStandard: false,
          });
        } else {
          message.error("图标类创建失败");
        }
      } else if (cardType === "edit") {
        if (!categoryNow.name || categoryNow.name.trim() === "") {
          message.warning("图标类名称不能为空");
          return;
        }
        const resp = await updateIconCategory(
          categoryNow.id,
          {
            name: categoryNow.name,
            iconIds: selectedIcons.map((icon) => icon.id),
          }
        );
        if (resp.code === 200) {
          // console.log(resp, "更新图标类成功");
          message.success("图标类更新成功");
          fetchCustomClasses({
            isStandard: false,
          });
        }
      } else if (cardType === "editCopy") {
        const nameToUse = className || classNow.name;
        if (!nameToUse || nameToUse.trim() === "") {
          message.warning("图标类名称不能为空");
          return;
        }
        //TODO副本操作
        const resp = await updateDuplicateIconCategory(
          classNow.id,
          {
            name: nameToUse,
            apiInterfaceName: classNow.apiInterfaceName,
            duplicateIcons: selectedIcons.map((icon) => ({
                id: icon.id,
                name: icon.name,
                apiInterfaceName: icon.apiInterfaceName || "",
              })),
          }
        )
        if (resp.code === 200) {
          // console.log(resp, "更新图标类副本成功");
          message.success("图标类副本更新成功");
          //更新layerNow对应的layerCount中的图标类副本数量
          const updatedLayerCount = layerCount.map((layer) => {
            if (layer.index === layerNow) {
              
              return {
                ...layer,
                duplicateIcons: selectedIcons,
              };
            }
            return layer;
          });
          setLayerCount(updatedLayerCount);
          setNewDuplicateIcons({
            index:layerNow,
            duplicateIcons:selectedIcons,
          });
          //更新setIconsNow
          const res = await getDuplicateIconList({
            duplicateCategoryId: classNow.id,
          });
          if (res.code === 200) {
            setIconsNow(res.data);
          }
        }
      }
    } catch (error) { }
    setDialogOpen(false);
    setSelectedIcons([]);
    setClassName("");
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          sx: { width: 600, maxWidth: "100%" },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: "flex", gap: 2, width: 600 }}>
          <p
            onClick={() => handleTabClick("standard")}
            style={{
              cursor: "pointer",
              color: selectedTab === "standard" ? "#1976d2" : undefined,
              fontWeight: selectedTab === "standard" ? "bold" : undefined,
              borderBottom:
                selectedTab === "standard"
                  ? "2px solid #1976d2"
                  : "2px solid transparent",
              marginRight: 16,
              padding: 4,
              transition: "color 0.2s, border-bottom 0.2s",
            }}
          >
            标准库
          </p>
          <p
            onClick={() => handleTabClick("custom")}
            style={{
              cursor: "pointer",
              color: selectedTab === "custom" ? "#1976d2" : undefined,
              fontWeight: selectedTab === "custom" ? "bold" : undefined,
              borderBottom:
                selectedTab === "custom"
                  ? "2px solid #1976d2"
                  : "2px solid transparent",
              padding: 4,
              transition: "color 0.2s, border-bottom 0.2s",
            }}
          >
            自定义类
          </p>
          <p
            onClick={() => handleTabClick("uncategorized")}
            style={{
              cursor: "pointer",
              color: selectedTab === "uncategorized" ? "#1976d2" : undefined,
              fontWeight: selectedTab === "uncategorized" ? "bold" : undefined,
              borderBottom:
                selectedTab === "uncategorized"
                  ? "2px solid #1976d2"
                  : "2px solid transparent",
              padding: 4,
              transition: "color 0.2s, border-bottom 0.2s",
            }}
          >
            未分类图标
          </p>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers className="dialogContent">
          {selectedTab === "standard" ? (
            <Typography gutterBottom>
              <div className="standardLibrary">
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: 20,
                  }}
                >
                  <Search
                    placeholder="搜索类名称"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onSearch={onSearch}
                    style={{ width: 400, textAlign: "center" }}
                    allowClear
                  />
                </div>
                <div
                  className="classList"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className="leftArrow"
                    onClick={handlePrev}
                    style={{
                      cursor: "pointer",
                      opacity: currentPage === 0 ? 0.5 : 1,
                    }}
                  >
                    <ArrowLeft sx={{ fontSize: 40, color: "#fff" }} />
                  </div>

                  <div className="classItems" style={{ height: 200, flex: 1 }}>
                    {currentIcons.length > 0 ? (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(4, 1fr)",
                          gap: "10px",
                        }}
                      >
                        {currentIcons.map((icon, index) => (
                          <Tooltip
                            title={icon.name}
                            zIndex={1000}
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentNode
                            }
                            key={index}
                          >
                            <div key={index} className="iconItem">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={async () => {
                                  setClassNow(icon);
                                  try {
                                    const res = await duplicateIconCategory({
                                      projectId: Number(localStorage.getItem("projectId")),
                                      categoryId: icon.id,
                                    })
                                    if (res.code === 200) {
                                      message.success("图标类副本创建成功");
                                      const rep = await getDuplicateIconList({
                                        duplicateCategoryId: res.data.id,
                                      })
                                      setImgs(rep.data);
                                      setIconsNow(rep.data);
                                    } else {
                                      message.error("图标类副本创建失败");
                                    }
                                  } catch (error) {
                                    console.error("创建图标类副本失败:", error);
                                    message.error("创建图标类副本失败");
                                  }
                                  handleClose();
                                }}
                              >
                                <img
                                  src={icon.url}
                                  alt={icon.name}
                                  style={{ width: 35, height: 35 }}
                                />

                                <p
                                  style={{
                                    color: "#fff",
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: 100,
                                  }}
                                >
                                  {icon.name}
                                </p>
                              </div>
                            </div>
                          </Tooltip>
                        ))}
                      </div>
                    ) : (
                      <Empty
                        description={
                          <span style={{ color: "#fff" }}>暂无图标</span>
                        }
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    )}
                  </div>

                  <div
                    className="rightArrow"
                    onClick={handleNext}
                    style={{
                      cursor: "pointer",
                      opacity: currentPage >= totalPages - 1 ? 0.5 : 1,
                    }}
                  >
                    <ArrowRight sx={{ fontSize: 40, color: "#fff" }} />
                  </div>
                </div>
              </div>
            </Typography>
          ) : (
            <Typography gutterBottom>
              <div className="standardLibrary" style={{ paddingBottom: 20 }}>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: 20,
                  }}
                >
                  {selectedTab === "custom" ? (
                    <Search
                      placeholder="搜索类名称"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      onSearch={onSearch}
                      style={{ width: 400, textAlign: "center" }}
                      allowClear
                    />
                  ) : (
                    <Search
                      placeholder="搜索图标名称"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      onSearch={onSearch}
                      style={{ width: 400, textAlign: "center" }}
                      allowClear
                    />
                  )}
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "right",
                    marginBottom: 20,
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#fff",
                      color: "#000",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "auto",
                    }}
                    onClick={() => {
                      setDialogOpen(true);
                      setClassName("");
                      localStorage.setItem("cardType", "create");
                    }}
                  >
                    <PlaylistAdd sx={{ marginRight: 1 }} />
                    创建图标类
                  </Button>
                </div>

                {selectedTab === "custom" ? (
                  <div
                    className="classList"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="leftArrow"
                      onClick={handleCustomPrev}
                      style={{
                        cursor: "pointer",
                        opacity: currentPage === 0 ? 0.5 : 1,
                      }}
                    >
                      <ArrowLeft sx={{ fontSize: 40, color: "#fff" }} />
                    </div>
                    <div
                      className="classItems"
                      style={{ height: 200, flex: 1 }}
                    >
                      {currentCustomClasses.length > 0 ? (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            gap: "10px",
                          }}
                        >
                          {currentCustomClasses.map((icon, index) => (
                            <Tooltip
                              title={icon.name}
                              zIndex={1000}
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              key={index}
                            >
                              <div key={index} className="iconItem">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={async () => {
                                    setClassNow(icon);
                                    try {
                                      const res = await duplicateIconCategory({
                                        projectId: Number(localStorage.getItem("projectId")),
                                        categoryId: icon.id,
                                      })
                                      if (res.code === 200) {
                                        message.success("图标类副本创建成功");
                                        const rep = await getDuplicateIconList({
                                          duplicateCategoryId: res.data.id,
                                        })
                                        setImgs(rep.data);
                                        setIconsNow(rep.data);
                                      } else {
                                        message.error("图标类副本创建失败");
                                      }
                                    } catch (error) {
                                      console.error("创建图标类副本失败:", error);
                                      message.error("创建图标类副本失败");
                                    }
                                    handleClose();
                                  }}
                                  onContextMenu={(e) => handleContextMenu(e, icon)}
                                >
                                  <img
                                    src={icon.url}
                                    alt={icon.name}
                                    style={{ width: 35, height: 35 }}
                                  />
                                  <p
                                    style={{
                                      color: "#fff",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: 100,
                                    }}
                                  >
                                    {icon.name}
                                  </p>
                                </div>
                              </div>
                            </Tooltip>
                          ))}
                        </div>
                      ) : (
                        <Empty
                          description={
                            <span style={{ color: "#fff" }}>暂无图标</span>
                          }
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                      )}
                    </div>
                    <div
                      className="rightArrow"
                      onClick={handleCustomNext}
                      style={{
                        cursor: "pointer",
                        opacity: currentPage >= totalCustomPages - 1 ? 0.5 : 1,
                      }}
                    >
                      <ArrowRight sx={{ fontSize: 40, color: "#fff" }} />
                    </div>
                    {contextMenu && (
                      <div
                        style={{
                          position: "fixed",
                          top: contextMenu.y,
                          left: contextMenu.x,
                          background: "#fff",
                          boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                          zIndex: 2000,
                          borderRadius: 4,
                          padding: "4px 0",
                        }}
                      >
                        <div onClick={handleEdit} className="context-menu-item" style={{ padding: "6px 20px", cursor: "pointer", whiteSpace: "nowrap" }}>编辑</div>
                        <div onClick={handleDelete} className="context-menu-item" style={{ padding: "6px 20px", cursor: "pointer", whiteSpace: "nowrap" }}>删除</div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="classList"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="leftArrow"
                      onClick={handleUnclassifiedPrev}
                      style={{
                        cursor: "pointer",
                        opacity: currentPage === 0 ? 0.5 : 1,
                      }}
                    >
                      <ArrowLeft sx={{ fontSize: 40, color: "#fff" }} />
                    </div>
                    <div
                      className="classItems"
                      style={{ height: 200, flex: 1 }}
                    >
                      {currentUnclassifiedIcons.length > 0 ? (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            gap: "10px",
                          }}
                        >
                          {currentUnclassifiedIcons.map((icon, index) => (
                            <Tooltip
                              title={icon.name
                                .split("/")
                                .pop()
                                .split("_")
                                .pop()}
                              key={index}
                              zIndex={1000}
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                            >
                              <div key={index} className="iconItem">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setImgs((prevImgs) => [...prevImgs, icon]);
                                    handleClose();
                                  }}
                                >
                                  <img
                                    src={icon.url}
                                    alt={icon.name}
                                    style={{ width: 35, height: 35 }}
                                  />
                                  <p
                                    style={{
                                      color: "#fff",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: 100,
                                    }}
                                  >
                                    {icon.name
                                      .split("/")
                                      .pop()
                                      .split("_")
                                      .pop()}
                                  </p>
                                </div>
                              </div>
                            </Tooltip>
                          ))}
                        </div>
                      ) : (
                        <Empty
                          description={
                            <span style={{ color: "#fff" }}>暂无图标</span>
                          }
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                      )}
                    </div>
                    <div
                      className="rightArrow"
                      onClick={handleUnclassifiedNext}
                      style={{
                        cursor: "pointer",
                        opacity:
                          currentPage >= totalUnclassifiedPages - 1 ? 0.5 : 1,
                      }}
                    >
                      <ArrowRight sx={{ fontSize: 40, color: "#fff" }} />
                    </div>
                  </div>
                )}
              </div>
              {
                selectedTab === "uncategorized" && (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 20 }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#fff",
                        marginBottom: 8,
                        width: 200,
                        textAlign: "center",
                        color: "#86909C",
                      }}
                      onClick={uploadImg}
                    >
                      从本地选择文件
                      <FileOpen sx={{ marginLeft: 1 }} />
                    </Button>
                  </div>
                )
              }
              <p
                style={{
                  textAlign: "center",
                  color: "#fff",
                  fontSize: 14,
                  position: "absolute",
                  bottom: 10,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                }}
              >
                想从Figma中快速导出图标？请在Figma中使用Libra插件
              </p>
            </Typography>
          )}
        </DialogContent>
      </BootstrapDialog>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setSelectedIcons([]);
          setClassName("");
        }}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          sx: { width: 500, maxWidth: "100%", backgroundColor: "#282828" },
        }}
      >
        <DialogTitle id="form-dialog-title">
          {/* //改为三种情况 create为创建图标类 edit为编辑图标类 editCopy为编辑图标类副本 */}
          {localStorage.getItem("cardType") === "create" ? "创建图标类" : localStorage.getItem("cardType") === "edit" ? "编辑图标类" : "编辑图标类副本"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            setDialogOpen(false);
            setSelectedIcons([]);
            setClassName("");
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div
              className="dialogInput"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <label
                style={{ marginRight: 8, minWidth: 100, textAlign: "center" }}
              >
                图标类名称:
              </label>
              <Input
                placeholder="图标类名称"
                value={
                  localStorage.getItem("cardType") === "create" ? className : localStorage.getItem("cardType") === "edit" ? categoryNow.name : classNow.name
                }
                onChange={(e) => {
                  if (localStorage.getItem("cardType") === "create") {
                    setClassName(e.target.value)
                  } else if (localStorage.getItem("cardType") === "edit") {
                    setCategoryNow({ ...categoryNow, name: e.target.value })
                  } else {
                    setClassNow({ ...classNow, name: e.target.value })
                  }
                }}
                style={{ marginBottom: 8, width: 200, textAlign: "center" }}
              />
            </div>
            {
              localStorage.getItem("cardType") === "editCopy" ? (
                <div
                  className="dialogInput"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <label
                    style={{ marginRight: 8, minWidth: 100, textAlign: "center" }}
                  >
                    <p>API接口名:</p>
                    <p>(开发者使用)</p>
                  </label>
                  <Input
                    placeholder="API接口名(开发者使用)"
                    value={classNow.apiInterfaceName}
                    onChange={(e) => setClassNow({ ...classNow, apiInterfaceName: e.target.value })}
                    style={{ marginBottom: 8, width: 200, textAlign: "center" }}
                  />
                </div>
              ) : (
                <div
                  className="dialogInput"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <label
                    style={{ marginRight: 8, minWidth: 70, textAlign: "right" }}
                  >
                    导入图标:
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                      width: 200,
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#fff",
                        marginBottom: 8,
                        width: 200,
                        textAlign: "center",
                        color: "#86909C",
                      }}
                      onClick={uploadImg}
                    >
                      从本地选择文件
                      <FileOpen sx={{ marginLeft: 1 }} />
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#fff",
                        marginBottom: 8,
                        width: 200,
                        textAlign: "center",
                        color: "#86909C",
                      }}
                      onClick={() => {
                        fetchicons();
                        setAddOpen(true);
                      }}
                    >
                      从未分类图标中选择
                      <FileOpen sx={{ marginLeft: 1 }} />
                    </Button>
                  </div>
                </div>
              )
            }
            {selectedIcons.length > 0 && (
              <div style={{ padding: "0 24px", marginTop: 20 }}>
                <div style={{ color: "#fff", marginBottom: 8 }}>
                  已选 {selectedIcons.length} 个图标：
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    justifyContent: "space-between",
                  }}
                >
                  <IconButton
                    onClick={() =>
                      setSelectedPage((prev) => Math.max(prev - 1, 0))
                    }
                    disabled={selectedPage === 0}
                    sx={{ color: "#fff" }}
                  >
                    <ArrowLeft />
                  </IconButton>

                  {/* 当前分页图标 */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(5, 1fr)",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    {selectedIcons
                      .slice(selectedPage * 5, selectedPage * 5 + 5)
                      .map((icon, index) => (
                        <div
                          key={icon.id}
                          style={{
                            position: "relative",
                            width: 60,
                            minHeight: 50,
                            backgroundColor: "#444",
                            borderRadius: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <img
                              src={icon.url}
                              alt={icon.id}
                              style={{ width: 30, height: 30 }}
                            />
                            {
                              localStorage.getItem("cardType") === "editCopy" && (
                                <div>
                                  <Tooltip title="图标名" placement="top" zIndex={1000}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }>
                                    <div style={{ width: "100%" }}>
                                      <Input
                                        value={icon.name}
                                        onChange={(e) => {
                                          const newIcons = [...selectedIcons];
                                          newIcons[selectedPage * 5 + index].name = e.target.value;
                                          setSelectedIcons(newIcons);
                                        }}
                                        placeholder="名称"
                                        style={{
                                          marginTop: 4,
                                          fontSize: 12,
                                          height: 24,
                                          padding: "0 4px",
                                        }}
                                      />
                                    </div>
                                  </Tooltip>
                                  <div>
                                    <Tooltip title="API接口名(开发者使用)" placement="top" zIndex={1000}
                                      getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                      }>
                                      <div style={{ width: "100%" }}>
                                        <Input
                                          value={icon.apiInterfaceName}
                                          onChange={(e) => {
                                            const newIcons = [...selectedIcons];
                                            newIcons[selectedPage * 5 + index].apiInterfaceName = e.target.value;
                                            setSelectedIcons(newIcons);
                                          }}
                                          placeholder="API"
                                          style={{
                                            marginTop: 4,
                                            backgroundColor: "#fff",
                                            fontSize: 12,
                                            height: 24,
                                            padding: "0 4px",
                                          }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                          <Popconfirm
                            zIndex={1000}
                            title="确认移除次图标？"
                            description={
                              <div style={{ width: 200 }}>
                                从这里移除图标，不会移除原有图标类的图标。此次移除只作用在您此次添加的图标类副本中。
                              </div>
                            }
                            onConfirm={() => {
                              setSelectedIcons((prev) =>
                                prev.filter((item) => item.id !== icon.id)
                              );
                            }}
                            okText="确定"
                            cancelText="取消"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentNode
                            }
                          >
                            <IconButton
                              size="small"
                              sx={{
                                position: "absolute",
                                top: -8,
                                right: -8,
                                backgroundColor: "#fff",
                                color: "#000",
                                width: 20,
                                height: 20,
                                fontSize: 12,
                              }}
                            >
                              ×
                            </IconButton>
                          </Popconfirm>
                        </div>
                      ))}
                  </div>

                  {/* 右箭头 */}
                  <IconButton
                    onClick={() =>
                      setSelectedPage((prev) =>
                        (prev + 1) * 5 < selectedIcons.length ? prev + 1 : prev
                      )
                    }
                    disabled={(selectedPage + 1) * 5 >= selectedIcons.length}
                    sx={{ color: "#fff" }}
                  >
                    <ArrowRight />
                  </IconButton>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button variant="contained" color="primary" onClick={createClass}>
            保存
          </Button>
        </DialogActions>
      </Dialog>
      <BootstrapDialog
        onClose={handleAddClose}
        aria-labelledby="customized-dialog-title"
        open={addOpen}
        PaperProps={{
          sx: { width: 700, maxWidth: "100%" },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: "flex", gap: 2, width: 700 }}>
          <p
            style={{
              cursor: "pointer",
              fontWeight: "bold",
              padding: 4,
              transition: "color 0.2s, border-bottom 0.2s",
            }}
          >
            未分类图标
          </p>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleAddClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers className="dialogContent">
          <Typography gutterBottom>
            <div className="standardLibrary" style={{ paddingBottom: 20 }}>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <Search
                  placeholder="搜索图标名称"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  onSearch={() => {
                    fetchicons({
                      name: searchValue,
                    });
                  }}
                  style={{ width: 400, textAlign: "center" }}
                  allowClear
                />
              </div>
              <p style={{ color: "#FFF" }}>
                已选：
                {
                  selectedIcons.filter((sel) =>
                    currentUnclassifiedIcons.some((icon) => icon.id === sel.id)
                  ).length
                }{" "}
                个图标
              </p>
              <div
                className="classList"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className="leftArrow"
                  onClick={handleUnclassifiedPrev}
                  style={{
                    cursor: "pointer",
                    opacity: currentPage === 0 ? 0.5 : 1,
                  }}
                >
                  <ArrowLeft sx={{ fontSize: 40, color: "#fff" }} />
                </div>

                <div className="classItems" style={{ height: 200, flex: 1 }}>
                  {currentUnclassifiedIcons.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "10px",
                      }}
                    >
                      {currentUnclassifiedIcons.map((icon, index) => {
                        const isSelected = selectedIcons?.some(
                          (item) => item.id === icon.id
                        );
                        return (
                          <Tooltip
                            title={icon.name}
                            zIndex={1000}
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentNode
                            }
                            key={icon.id}
                          >
                            <div
                              className="iconItem"
                              onClick={() =>
                                toggleIconSelect({ id: icon.id, url: icon.url })
                              }
                              style={{
                                position: "relative",
                                border: isSelected
                                  ? "2px solid #00b96b"
                                  : "2px solid transparent",
                                borderRadius: 4,
                                padding: 4,
                                backgroundColor: isSelected
                                  ? "rgba(0, 185, 107, 0.1)"
                                  : "transparent",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src={icon.url}
                                alt={icon.name}
                                style={{ width: 35, height: 35 }}
                              />
                              <p
                                style={{
                                  color: "#fff",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: 100,
                                  marginTop: 4,
                                }}
                              >
                                {icon.name}
                              </p>

                              {/* 对钩标记 */}
                              {isSelected && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    width: 16,
                                    height: 16,
                                    backgroundColor: "#00b96b",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontSize: 12,
                                    fontWeight: "bold",
                                  }}
                                >
                                  ✓
                                </div>
                              )}
                            </div>
                          </Tooltip>
                        );
                      })}
                    </div>
                  ) : (
                    <Empty
                      description={
                        <span style={{ color: "#fff" }}>暂无图标</span>
                      }
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  )}
                </div>

                <div
                  className="rightArrow"
                  onClick={handleUnclassifiedNext}
                  style={{
                    cursor: "pointer",
                    opacity:
                      currentPage >= totalUnclassifiedPages - 1 ? 0.5 : 1,
                  }}
                >
                  <ArrowRight sx={{ fontSize: 40, color: "#fff" }} />
                </div>
              </div>
            </div>
          </Typography>
        </DialogContent>
        {/* <DialogActions
          style={{ justifyContent: "center" }}
          className="dialogContent"
        >
          <Button
            variant="contained"
            color="primary"
            disabled={selectedIcons.size === 0}
            onClick={() => {
              console.log(selectedIcons, "selectedIcons");
              handleAddClose();
            }}
          >
            保存
          </Button>
        </DialogActions> */}
      </BootstrapDialog>

    </React.Fragment>
  );
}
